import { Pipe, PipeTransform } from "@angular/core";
import { User } from "src/app/modules/portal/users/user.type";
import { Entity } from "../../types/entity.type";
import { UserInfo, UserTypes } from "../../types/user-info";

@Pipe({
  name: "checkEditUserPermissions",
})
export class CheckEditUserPermissionsPipe implements PipeTransform {
  transform(mainCondition: boolean, { currentUser, userToEdit }: { currentUser: UserInfo; userToEdit: User }): boolean {
    if (!mainCondition) {
      return false;
    }

    const canUpdateEntity =
      (currentUser.isGlobal() && currentUser.hasRight(["admin", "manager"])) ||
      currentUser.isPartnerAdmin() ||
      (currentUser.isCompanyAdmin() && currentUser.companyId === userToEdit.companyId) ||
      (currentUser.isPartner() && currentUser.hasRight(["manager"]) && !!userToEdit.companyId);

    return canUpdateEntity ? allowUpdateEntity(userToEdit, currentUser) : false;
  }
}
function allowUpdateEntity(entity: Entity, user: UserInfo): boolean {
  if (user.hasRight(["admin", "manager"])) {
    if (
      user.isGlobal() ||
      (user.isPartner() &&
        (entity?.extraInfo.createdByType === UserTypes.Partner ||
          entity?.extraInfo.createdByType === UserTypes.Company)) ||
      (user.isCompany() && entity?.extraInfo.createdByType === UserTypes.Company)
    )
      return true;
  }
  return false;
}
